//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"APillarFacetGeometry",0,"SelectNXObjectList",0],[0,"APillarGeometry",1,"ScCollector",0],[0,"APillarSide",1,0],[1,"AdditionalGeometry",0,"SelectNXObjectList",0],[0,"AnalysisMethod",1,0],[0,"Configuration",1,"Features.VehicleDesign.ConfigurationBuilder",0],[0,"EyeDefinition",1,"Features.VehicleDesign.EyeDefinitionBuilder",0],[0,"EyeRotationAngle",1,1],[1,"EyeRotationAngleExp",0,"Expression",0],[0,"GenerateValidationLogFile",1,0],[0,"HeadTurnAngle",1,1],[1,"HeadTurnAngleExp",0,"Expression",0],[0,"OuterEdge",1,"ScCollector",0],[0,"OuterPoint",1,"Point",0],[0,"PositionType",1,0],[0,"TargetObstructionAngle",1,1],[1,"TargetObstructionAngleExp",0,"Expression",0],[0,"ViewValidationResults",1,0]],[[[],"Illustration",{},0,0],[[],"ValidationButton",{},0,0]],[]];
SPLM.Features.VehicleDesign.APillarObstructionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.APillarObstructionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.APillarObstructionBuilder.AnalysisType = Object.freeze({
    "APillarGeometry" : "APillarGeometry", "CreateCriteriaGeometry" : "CreateCriteriaGeometry"});

SPLM.Features.VehicleDesign.APillarObstructionBuilder.Position = Object.freeze({
    "OuterPointofAPillarSection" : "OuterPointofAPillarSection", "OuterEdgeofAPillar" : "OuterEdgeofAPillar", "EyeHeadTurnAngle" : "EyeHeadTurnAngle"});

SPLM.Features.VehicleDesign.APillarObstructionBuilder.APillarSideType = Object.freeze({
    "LeftSide" : "LeftSide", "RightSide" : "RightSide"});

export default SPLM;